import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ActionQueuedResponse,
  GetPartnerNameByMpnIdRequest,
  GetPartnerNameByMpnIdResponse,
  ValidateEntraTenantIdRequest,
  ValidateEntraTenantIdResponse,
} from '@models/csp/csp-util.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class CspUtilService {
  private readonly url = `${environment.bffUrl}/csp`;
  constructor(private httpClient: HttpClient) {}

  getPartnerNameByMpnId(req: GetPartnerNameByMpnIdRequest): Observable<GetPartnerNameByMpnIdResponse> {
    return this.httpClient.post<GetPartnerNameByMpnIdResponse>(`${this.url}/get-partner-name-by-mpn-id`, req);
  }

  refreshCustomerSubscriptions(customerTenantId: string): Observable<void> {
    return this.httpClient.post<void>(`${this.url}/customers/${customerTenantId}/refresh-subscriptions`, undefined);
  }

  refreshPartnerCustomers(partnerId: string): Observable<ActionQueuedResponse> {
    return this.httpClient.post<ActionQueuedResponse>(`${this.url}/partners/${partnerId}/refresh-customers`, undefined);
  }

  validateEntraTenantId(request: ValidateEntraTenantIdRequest): Observable<ValidateEntraTenantIdResponse> {
    return this.httpClient.post<ValidateEntraTenantIdResponse>(`${this.url}/partners/validate-entra-id`, request);
  }
}
